import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  compose,
  lifecycle,
  branch,
  renderNothing,
} from 'recompose'

import { contains, any } from 'ramda'
import { THIRD_PARTY_LOGIN_PROVIDERS } from 'constants/loginConstants'

import config from 'config'
import * as actions from 'modules/org/actions'
import * as UserActions from 'modules/user/actions'
import * as UserSelectors from 'modules/user/selectors'
import * as GeolocationSelectors from 'modules/geolocation/selectors'
import * as GeolocationActions from 'modules/geolocation/actions'
import * as BillingActions from 'modules/billing/actions'

import { authenticateWithCode } from '@drifthq/web-auth'

import App from './component'

// http://developers.marketo.com/javascript-api/lead-tracking/#embedding_the_code
const loadMarketo = () => {
  let didInit = false
  function initMunchkin() {
    if(didInit === false) {
      didInit = true
      window.Munchkin.init(config.MARKETO_ID)
    }
  }
  const s = document.createElement('script')
  s.type = 'text/javascript'
  s.async = true
  s.src = '//munchkin.marketo.net/munchkin.js'
  s.onreadystatechange = function() {
    if (this.readyState === 'complete' || this.readyState === 'loaded') {
      initMunchkin()
    }
  }
  s.onload = initMunchkin
  document.getElementsByTagName('head')[0].appendChild(s)
}

const mapStateToProps = state => ({
  isFetchGeolocationPending: GeolocationSelectors.isFetchGeolocationPending(state),
  isGeolocationLoaded: GeolocationSelectors.isGeolocationLoaded(state),
  // If we failed to fetch geolocation data, assume that the visitor may be
  // coming from a GDPR-applicable IP address.
  isGdprConsentRequired: GeolocationSelectors.isFetchGeolocationFailure(state) || GeolocationSelectors.getIsGdprApplicable(state),
  ssoRedirectError: UserSelectors.ssoRedirectError(state)
})

const resolveCode = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('code')
}

const isThirdPartyLogin = () => {
  const path = window.location.pathname
  return path && any((provider) => contains(provider, path), THIRD_PARTY_LOGIN_PROVIDERS)
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    signup: actions.signup,
    setResetToken: UserActions.setResetToken,
    setSSOProvisionedFlow: UserActions.setSSOProvisionedFlow,
    fetchGeolocation: GeolocationActions.fetchGeolocation,
    fetchUser: UserActions.fetchUser,
    setEmail: UserActions.setEmail,
    setFlow: UserActions.setFlow,
    getLoginUrl: UserActions.getLoginUrl,
    setDisabledEmail: UserActions.setDisabledEmail,
    setPlan: BillingActions.setPlan,
    setCoupon: BillingActions.setCoupon,
    fetchEmailFromRelay: UserActions.fetchEmailFromRelay,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    async componentDidMount() {
      if (!isThirdPartyLogin() && !!resolveCode()) {
        await authenticateWithCode({ authorizationCode: resolveCode(), clientId: config.CLIENT_ID })
      }

      loadMarketo()

      if (!this.props.isGeolocationLoaded && !this.props.isFetchGeolocationPending) {
        this.props.actions.fetchGeolocation()
      }
    }
  }),
  branch(props => !props.isGeolocationLoaded, renderNothing),
)(App)



// WEBPACK FOOTER //
// ./src/layouts/App/index.js